import { useMutation } from "@tanstack/react-query";
import { useAccessToken, useTenantData } from "@/hooks";
import { PaymentApi } from "@/openapi/generated";
import { createAuthenticatedApi } from "@/lib/utils";
import { resolveVerifyPayJunctionTransactionId } from "@/features/balance/utils/payment";

interface UsePaymentVerifyParams {
  tokenId: string;
}

export const usePaymentVerify = () => {
  const accessToken = useAccessToken();
  const { tenantId } = useTenantData();

  return useMutation({
    mutationFn: async ({ tokenId }: UsePaymentVerifyParams) => {
      if (!accessToken) {
        throw new Error("Authentication token is required");
      }
      const service = createAuthenticatedApi(PaymentApi, accessToken);
      const response = await service.apiPaymentsVerifyPost({
        verifyPayJunctionRequest: { tokenId },
        xTenantID: tenantId,
      });
      resolveVerifyPayJunctionTransactionId(response);
      return response;
    },
  });
};
